import { registerPlugin, PluginListenerHandle } from '@capacitor/core';

export interface DynamicTypePlugin {
  /**
   * Obtém a categoria de tamanho de conteúdo atual do iOS
   */
  getContentSizeCategory(): Promise<{ category: string; scale: number }>;
  
  /**
   * Adiciona listener para mudanças de Dynamic Type
   */
  addListener(
    eventName: 'contentSizeCategoryChanged',
    listenerFunc: (info: { category: string; scale: number }) => void
  ): Promise<PluginListenerHandle>;
  
  /**
   * Remove todos os listeners
   */
  removeAllListeners(): Promise<void>;
}

const DynamicType = registerPlugin<DynamicTypePlugin>('DynamicType', {
  web: () => import('./DynamicTypePluginWeb').then(m => new m.DynamicTypePluginWeb()),
});

export default DynamicType;
